import { useQuery } from '@tanstack/react-query';

import { storyClient } from '@modules/Stories/client/storyClient';
import { cacheKeys } from '../config';



export type Params = {
    id: number;
};

type Options = {
    enabled: boolean
};

const defaultOptions: Partial<Options> = {
  enabled: true,
};

export const useStoryQuery = (params: Params, options: Partial<Options> = defaultOptions) => {
  const { data: { data } = {}, ...rest } = useQuery({
    queryKey: [cacheKeys.getStory, params.id],
    queryFn: () => storyClient.getStory(params),
    enabled: options.enabled !== undefined ? options.enabled : defaultOptions.enabled,
  });

  return {
    ...rest,
    story: data,
  };
};
